import { combineReducers } from "redux";
import locale from "./Lang/reducer";
import snackbar from "./Snackbar/reducer";
import loader from "./Loader/reducer";
import navigation from "./Navigation/reducer";
import auth from "./Auth/reducer";
import products from "./Products/reducer";
import lookups from "./Lookups/reducer";
import notifications from "./Notifications/reducer";
import categories from "./Categories/reducer";
import subCategories from "./SubCategories/reducer";
import users from "./Users/reducer";
import businessVerification from "./BusinessVerification/reducer";
import vouchers from "./Vouchers/reducer";
import transactions from "./Transactions/reducer";
import employees from "./Employees/reducer";
import roles from "./Roles/reducer";

export default combineReducers({
  locale,
  snackbar,
  loader,
  navigation,
  auth,
  products,
  lookups,
  notifications,
  categories,
  subCategories,
  users,
  businessVerification,
  vouchers,
  transactions,
  employees,
  roles
});
